import { connect } from 'react-redux';

import { agreeCookie } from 'actions/global';

import { languageMapRoute } from 'util/i18n';

import App from './component';

const mapStateToProps = ({
	global: { route: { loading, entering, changing }, cookie },
	routing: { locationBeforeTransitions: { pathname } },
	i18n: { lan },
}) => ({
	loading: loading.length > 0 || entering.length > 0 || changing.length > 0,
	hideHeaderFooter: pathname.includes('print'),
	displayCookie: cookie.display,
	routeName: languageMapRoute(lan),
});

const mapDispatchToProps = dispatch => ({
	onAgreeCookie: () => dispatch(agreeCookie()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/layouts/App/index.js